// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  overflow-wrap: break-word;
}

.tinymceWrapper::ng-deep strong {
  font-weight: bold !important;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-tinymce/storyblok-tinymce.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAGE;EACE,4BAAA;AAAJ","sourcesContent":[":host {\n  overflow-wrap: break-word;\n}\n\n.tinymceWrapper::ng-deep {\n  strong {\n    font-weight: bold !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
